<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="forgive-forget-fulfil">
<h1>Forgive, Forget, Fulfil</h1>
<p style="text-indent:0px;">Do you think of yesterday?</p>
<p style="text-indent:0px;">Do you still dream of the past?</p>
<p style="text-indent:0px;">Do you shudder from dismay?</p>
<p style="text-indent:0px;">Is your soul’s flag at half-mast?</p><br/>
<p style="text-indent:0px;">Do you wish you could change?</p>
<p style="text-indent:0px;">Do you miss your dreams?</p>
<p style="text-indent:0px;">A whole life to re-arrange,</p>
<p style="text-indent:0px;">To pay out new scenes?</p><br/>
<p style="text-indent:0px;">Think about it for a while,</p>
<p style="text-indent:0px;">Just sit and wait.</p>
<p style="text-indent:0px;">Put your demons in single file,</p>
<p style="text-indent:0px;">Leave the rest to fate.</p><br/>
<p style="text-indent:0px;">What has been has been,</p>
<p style="text-indent:0px;">Though difficult, I know.</p>
<p style="text-indent:0px;">Now gather up steam,</p>
<p style="text-indent:0px;">Just let it go.</p><br/>
<p style="text-indent:0px;">Forgive your own being,</p>
<p style="text-indent:0px;">Then you will be able to rest.</p>
<p style="text-indent:0px;">Forward you shall begin seeing,</p>
<p style="text-indent:0px;">Your heart won’t detest.</p><br/>
<p style="text-indent:0px;">Those that you did deceive,</p>
<p style="text-indent:0px;">Show that you are truthful.</p>
<p style="text-indent:0px;">Ask them if you can receive,</p>
<p style="text-indent:0px;">Forgiveness for your evil.</p><br/>
<p style="text-indent:0px;">It may take a thousand years,</p>
<p style="text-indent:0px;">It might take just a minute.</p>
<p style="text-indent:0px;">It might take a hundred tears,</p>
<p style="text-indent:0px;">It is, yes, worth it!</p><br/>
<p style="text-indent:0px;">You can live in peace,</p>
<p style="text-indent:0px;">Be rid of the tempest of pain.</p>
<p style="text-indent:0px;">You can sign a new lease,</p>
<p style="text-indent:0px;">For life, a new life to live again.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch013.vue?ccfae064